import PlansList from '../../components/Corporates/PlansList';
import GroupsList from '../../components/Corporates/GroupsList';

const CorporateDetails = ({ corporateId }) => {
  return (
    <div>
      <div>
        <PlansList corporateId={corporateId} />
        <hr />
        <GroupsList corporateId={corporateId} />
      </div>
    </div>
  );
};
export default CorporateDetails;
